module.exports = window["wcStripeModules"]["checkout-modules"];